import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Footer } from '../components/Footer';
export function ThankYou1Page() {
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900 pt-10 md:pt-16 flex flex-col" data-id="element-1016">
      <main className="max-w-3xl mx-auto px-4 pb-20 flex-grow w-full" data-id="element-1017">
        <motion.section {...fadeIn} className="text-center py-10 md:py-16" data-id="element-1018">
          <CheckCircle2 className="w-20 h-20 text-[#2E7D32] mx-auto mb-6" data-id="element-1019" />
          <h1 className="text-4xl md:text-5xl font-black text-[#2E7D32] leading-tight mb-4" data-id="element-1020">
            ¡Gracias por tu compra!
          </h1>
          <p className="text-xl text-gray-700 font-medium" data-id="element-1021">
            Tu pedido fue procesado exitosamente.
          </p>
        </motion.section>

        <motion.section {...fadeIn} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 mb-8 text-center" data-id="element-1022">
          <p className="text-lg text-gray-700" data-id="element-1023">
            Pronto recibirás un email con los detalles de tu compra y el acceso
            a tu producto.
          </p>
        </motion.section>

        {/* INSTRUCCIONES DE ACCESO */}
        <motion.section {...fadeIn} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border-2 border-[#FFE0B2] mb-8" data-id="element-1024">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-1025">
            <span className="text-3xl" data-id="element-1026">🔑</span>
            <h2 className="text-2xl md:text-3xl font-black text-gray-900" data-id="element-1027">
              ¿Cómo accedo a mis contenidos?
            </h2>
          </div>

          <div className="space-y-4 text-lg text-gray-700 text-center" data-id="element-1028">
            <p data-id="element-1029">
              Cuando vayas a <strong data-id="element-1030">descargar o ver tus contenidos</strong>, el
              sistema te pedirá una <strong data-id="element-1031">contraseña</strong>.
            </p>
            <div className="bg-[#FFF3E0] rounded-2xl p-6 border border-[#FFE0B2] my-6" data-id="element-1032">
              <p className="font-bold text-gray-900 mb-2" data-id="element-1033">
                Tu contraseña es tu dirección de email de compra completa
              </p>
              <p className="text-gray-600 mb-3" data-id="element-1034">
                Incluí el <strong data-id="element-1035">@</strong> y el dominio completo, tal cual lo
                usaste al comprar.
              </p>
            </div>
          </div>
        </motion.section>

        {/* SOPORTE */}
        <motion.section {...fadeIn} className="bg-[#E8F5E9] rounded-3xl p-8 md:p-10 shadow-sm border border-[#C8E6C9] text-center" data-id="element-1036">
          <span className="text-3xl block mb-3" data-id="element-1037">💬</span>
          <p className="text-lg text-[#2E7D32] font-bold mb-2" data-id="element-1038">
            ¿Tenés alguna duda?
          </p>
          <p className="text-gray-700" data-id="element-1039">
            Escribinos a{' '}
            <strong className="text-[#2E7D32]" data-id="element-1040">
              nutrinaturalonline@gmail.com
            </strong>{' '}
            — es nuestro soporte y estaremos para responderte lo antes posible.
          </p>
        </motion.section>
      </main>

      <Footer data-id="element-1041" />
    </div>;
}